import {
  ClassOfBusinessId,
  CobMeta,
  CobMetaService,
} from '@lockton-apps/shared/util/constants';
import { includes, transform } from 'lodash';
import { Partners } from '@lockton-apps/shared/interfaces';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AdditionalProductsDetailsService {
  constructor(private readonly cobMeta: CobMetaService) {}

  getDetails<TResult = CobMeta, TCob = ClassOfBusinessId>(
    allProductIds: string[],
    selectedProducts: number[],
    partner: Partners,
    customizer: (meta: CobMeta, cob: TCob) => TResult
  ): TResult[] {
    return transform(
      allProductIds,
      (result: TResult[], id: string) => {
        const isDueToRenewal: boolean = includes(
          selectedProducts,
          this.cobMeta.getClassOfBusinessById(id)
        );

        if (!isDueToRenewal) {
          const meta: CobMeta = this.cobMeta.getClassOfBusinessMetaById(
            id,
            partner
          ) as CobMeta;
          const cob: TCob = this.cobMeta.getClassOfBusinessById(
            id,
            partner
          ) as TCob;

          result.push(customizer(meta, cob));
        }
      },
      []
    );
  }
}
